<router-outlet></router-outlet>
<app-layout-manager-footer></app-layout-manager-footer>
